module.exports = __webpack_public_path__ + "img/minus-square.41040584.svg";